import { useEffect, useState } from "react";
import tickImage from "../../assets/images/double-tick.png";
import lodingImage from "../../assets/images/loadingSpin.png";
import noteImage from "../../assets/images/notes.png";
import plusImage from "../../assets/images/plus.png";
import {
  useAddTodoMutation,
  useGetTodosQuery,
  useUpdateTodoMutation
} from "../../features/todoApi/todoApiSlice";

export default function Header() {
  const [input, setInput] = useState("");
  const [completeAllLoading, setCompleteAllLoading] = useState(false);

  const [addTodo, { isLoading: addIsLoading, isSuccess: addIsSuccess }] =
    useAddTodoMutation();
  const [updateTodo] = useUpdateTodoMutation();
  const { data: todos } = useGetTodosQuery({ complete: false });

  const handleInput = (e) => {
    setInput(e.target.value);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    addTodo({ text: input, completed: false, color: "" });
  };

  useEffect(() => {
    if (!addIsLoading && addIsSuccess) {
      setInput("");
    }
  }, [addIsLoading, addIsSuccess]);

  const completeHadler = async () => {
    setCompleteAllLoading(true);
    let promiseArray = [];
    todos?.forEach((todo) => {
      promiseArray.push(
        updateTodo({
          id: todo?.id,
          data: {
            completed: true,
          },
          RefetchAllTodos: true,
        }).unwrap()
      );
    });

    Promise.all(promiseArray).then(() => setCompleteAllLoading(false));
  };

  return (
    <div>
      <form
        className="flex items-center bg-gray-100 px-4 py-4 rounded-md"
        onSubmit={submitHandler}
      >
        <img src={noteImage} className="w-6 h-6" alt="Add todo" />
        <input
          type="text"
          placeholder="Type your todo"
          className={`w-full text-lg px-4 py-1 border-none outline-none bg-gray-100 text-gray-500 ${
            addIsLoading && "animate-pulse text-gray-700"
          }`}
          value={input}
          onChange={handleInput}
        />
        <button
          type="submit"
          className={`appearance-none w-8 h-8 bg-[url('${
            addIsLoading ? lodingImage : plusImage
          }')] bg-no-repeat bg-contain ${
            addIsLoading && "bg-bottom animate-spin !bg-cover m-0 p-0"
          }`}
        ></button>
      </form>
      <ul className="flex justify-between my-4 text-xs text-gray-500">
        <li
          className={`flex space-x-1 cursor-pointer ${
            completeAllLoading && "animate-pulse text-gray-700"
          }`}
          onClick={completeHadler}
        >
          <img
            className={`w-4 h-4 ${
              completeAllLoading && "bg-bottom animate-spin !bg-cover m-0 p-0"
            }`}
            src={completeAllLoading ? lodingImage : tickImage}
            alt="Complete"
          />
          <span>Complete All Tasks</span>
        </li>
      </ul>
    </div>
  );
}
